export function clampPct(n: number): number {
  if (Number.isNaN(n)) return 0;
  return Math.max(0, Math.min(100, n));
}

export function gaugeDash(percent: number, circumference: number): { dash: number; gap: number } {
  const dash = (clampPct(percent) / 100) * circumference;
  return { dash, gap: circumference - dash };
}

export function scaleBars(values: number[], maxPx: number): number[] {
  const max = Math.max(0, ...values);
  if (max === 0) return values.map(() => 0);
  return values.map((v) => Math.round((Math.max(0, v) / max) * maxPx));
}

export function heatIntensity(count: number, max: number): number {
  if (max <= 0) return 0;
  return Math.max(0, Math.min(1, count / max));
}

/**
 * Round a max value up to a "nice" axis ceiling (1/2/5 × 10^n), so a chart's
 * y-axis shows clean numbers (e.g. 87 → 100, 320 → 500) and the line never
 * touches the very top. Always ≥ 1.
 */
/** Y-axis tick fractions of the ceiling: [max, mid, zero]. */
export const Y_TICK_FRACTIONS = [1, 0.5, 0] as const;

export function niceCeil(v: number): number {
  if (v <= 1) return 1;
  const exp = Math.floor(Math.log10(v));
  const base = 10 ** exp;
  const f = v / base;
  const nice = f <= 1 ? 1 : f <= 2 ? 2 : f <= 5 ? 5 : 10;
  return nice * base;
}
